import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { connect } from 'react-redux'
import iconNew from '../../../assets/icons/new-light.svg'
import Pagination from '../../../components/pagination/pagination.component'
import './profiles.styles.scss'
import Service from './profiles.service'
import { FormatDate } from '../../../utils/UIHelper'
import iconDelete from '../../../assets/icons/delete-red.svg'
import iconEdit from '../../../assets/icons/edit-dark.svg'
import DeleteProfile from './components/delete/delete.component'

class Profile extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadProfiles()
    }

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.service.loadProfiles())
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                value: "",
                [e.target.name]: e.target.value
            }
        })
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadProfiles()
    }

    toggleShowDelete = profile => this.setState({
        ...this.state,
        showDelete: !this.state.showDelete,
        profileToDelete: profile
    })

    onDelete = () => this.setState({
        ...this.state,
        showDelete: false,
        profiles: this.state.profiles.filter(profile => profile.id !== this.state.profileToDelete.id)
    })

    render() {
        return (
            <>
                {this.state.loadingProfiles && <Dialog><Loading /></Dialog>}
                {this.state.showDelete && <Dialog><DeleteProfile profile={this.state.profileToDelete} onDelete={this.onDelete} onCancel={() => this.toggleShowDelete(null)} /></Dialog>}
                <div className="profiles">
                    <div className="header">
                        <h4>Profiles</h4>
                        <div className="buttons">
                            <Link className="btn" to="/internet/profile/create"><img alt="" src={iconNew} />New Profile</Link>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Rate Limit</th>
                                <th>IP Pool</th>
                                <th>Nas</th>
                                <th>Created</th>
                                <th>Updated</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.profiles.map((profile, key) => <tr key={key}>
                                    <td>{profile.name}</td>
                                    <td>{profile.description}</td>
                                    <td>{profile.rateLimit}</td>
                                    <td>{profile.ipPool}</td>
                                    <td>{profile.nasProfiles.length}</td>
                                    <td>{FormatDate(profile.created * 1000)}</td>
                                    <td>{FormatDate(profile.updated * 1000)}</td>
                                    <td>
                                        <div className="actions">
                                            <img alt="" src={iconEdit} onClick={() => this.props.history.push('/internet/profile/' + profile.id)} />
                                            <img alt="" src={iconDelete} onClick={() => this.toggleShowDelete(profile)} />
                                        </div>
                                    </td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    {
                        this.state.total > 0 && <Pagination totalItemsCount={this.state.total} currentIndex={this.state.currentPage} itemsPerPage={this.state.pageSize} onChange={this.onPageChange} />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Profile))